<template>
    <div>
      <div style="padding-bottom:0.2rem;font-weight:bold;font-size:1.05rem;color: rgba(33,33,33,0.9);">资源监控</div>
      <v-row style="text-align:center;width:100%;margin:auto;">
          <v-col :cols="4" style="padding:0.1rem 0.2rem;">
            <v-card @click="goDeviceList(-1)" color="#fff" flat dark>
              <div class="us_header_stats" style="background: #0c9de0 url('/res/dev_total.jpg');background-size: 100% 100%;">
                <div class="us_block_title">设备总数</div>
                <div class="us_header_stats_count">{{stat.total}}</div>
              </div>
            </v-card>
          </v-col>
          <v-col :cols="4" style="padding:0.1rem 0.2rem;">
            <v-card @click="goDeviceList(2)" color="#fff" flat dark>
              <div class="us_header_stats" style="background: #24c969 url('/res/dev_online.jpg');background-size: 100% 100%;">
                <div class="us_block_title">正常数</div>
                <div class="us_header_stats_count">{{stat.online}}</div>
              </div>
            </v-card>
          </v-col>
          <v-col :cols="4" style="padding:0.1rem 0.2rem;">
            <v-card @click="goDeviceList(1)" color="#fff" flat dark>
              <div class="us_header_stats" style="background: #0c9de0 url('/res/dev_offline.jpg');background-size: 100% 100%;">
                <div class="us_block_title">异常数</div>
                <div class="us_header_stats_count">{{stat.offline}}</div>
              </div>
            </v-card>
          </v-col>
      </v-row>
    </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      stat: {
        total: 0,
        online: 0,
        offline: 0
      },
      timeout: null
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.getStatDataTask();
  },
  destroyed() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  activated() {
    this.getStatDataTask();
  },
  deactivated() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  methods: {
    async getStatData() {
      var that = this
      var res = await that.$api.iot.statTotal()
      // .then(res => {
      //   // console.log('statTotal', res);
      //   if (!res.success) {
      //     console.log('获取设备统计数量失败', res);
      //     return
      //   }
      //   var data = res.data
      //   that.stat = data
      // })
      // console.log('statTotal', res);
      if (!res.success) {
        console.log('获取设备统计数量失败', res);
        return
      }
      var data = res.data
      that.stat = data
    },
    goDeviceList(state) {
      var query = {
        state: state
      }
      this.$router.goPage({ path: '/DeviceList', query: query })
    },
    async getStatDataTask() {
      var that = this;
      if (that.timeout) {
        window.clearTimeout(that.timeout);
      }
      await that.getStatData();
      that.timeout = setTimeout(that.getStatDataTask, 30 * 1000);
    }
  }
}
</script>

<style scoped>
.us_header_stats{
  padding-top:0.65rem;
  padding-bottom:0.2rem;
  border-radius:0.2rem;
  color:#fff;
  background-size:100% 100%;
  box-shadow: 0 1px 2px -2px rgba(0,0,0,.16), 0 3px 6px 0 rgba(0,0,0,.12), 0 5px 12px 4px rgba(0,0,0,.09);
}
.us_block_title{
  font-size:0.83rem;
  margin-top:0.5rem;
  color:rgba(255, 255, 255, 0.8);
}
.us_header_stats_count{
  font-size:2rem;
  margin-top:0.6rem;
  margin-bottom:0.4rem;
}
</style>
